export default class URLHelper {
    static slug(name) {
        if ("string" !== typeof name) name = "" + name;

        name = name.toLowerCase();

        //Remove quotes
        name = name.replace(/['"]/g, "");

        //Replace non characters & digits with -
        name = name.replace(/[^0-9a-z]+/g, "-");

        //Remove leading & trailing hyphens
        name = name.replace(/-{2,}/g, "-");
        name = name.replace(/-+$/g, "");
        name = name.replace(/^-+/g, "");

        return name;
    }

    static normalise_url(url) {
        if (!url) return url;

        if (!new RegExp("^(https?:)?//.+", "i").test(url)) {
            url = "http://" + url;
        }

        return url;
    }

    static prettify_url(url, removeWww = true, removePath = false) {
        url = this.normalise_url(url);
        let a = document.createElement('A');
        a.href = url;

        if (removeWww && a.host) {
            a.host = a.host.replace(/^www\./, '');
        }

        if (removePath || a.pathname === "/") {
            a.pathname = "";
        }

        return a.host + a.pathname + a.search;
    }

    static is_site_url(url) {
        return /^\/[^\/]/.test(url) || url.indexOf(window.CONFIG.urls.website) === 0;
    }
}
